import { render, staticRenderFns } from "./RelapseSchedule.vue?vue&type=template&id=74df2200&scoped=true&"
import script from "./RelapseSchedule.vue?vue&type=script&lang=js&"
export * from "./RelapseSchedule.vue?vue&type=script&lang=js&"
import style0 from "./RelapseSchedule.vue?vue&type=style&index=0&id=74df2200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74df2200",
  null
  
)

export default component.exports